import React from 'react'
import { Flexbox, Form, Mask } from '@/components'
import PropTypes from 'prop-types'

function FormFields({
  errors, touched, values, setFieldValue,
}) {
  return (
    <>
      <Flexbox.Column className="col-12">
        <Form.Group>
          <Form.Label htmlFor="fullName">
            Nome <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField
            name="fullName"
            autoFocus
            id="fullName"
            autoComplete="off"
            placeholder="Nome"
          />
          {touched?.fullName && errors?.fullName ? (
            <Form.Hint className="text-error">
              {String(errors.fullName)}
            </Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-12">
        <Form.Group>
          <Form.Label htmlFor="displayName">
            Apelido <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField
            name="displayName"
            id="displayName"
            autoComplete="off"
            placeholder="Apelido"
          />
          {touched?.displayName && errors?.displayName ? (
            <Form.Hint className="text-error">
              {String(errors.displayName)}
            </Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-6">
        <Form.Group>
          <Form.Label htmlFor="documentNumber">
            Documento <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField name="documentNumber">
            {({ field }) => (
              <Mask.CpfCnpj
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...field}
                id="documentNumber"
                placeholder="CPF ou CNPJ"
                value={values.documentNumber || ''}
                onAccept={(value) => setFieldValue('documentNumber', value)}
              />
            )}
          </Form.ValidationField>
          {touched?.documentNumber && errors?.documentNumber ? (
            <Form.Hint className="text-error">
              {String(errors.documentNumber)}
            </Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-6">
        <Form.Group>
          <Form.Label htmlFor="phoneNumber">
            Telefone <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField name="phoneNumber">
            {({ field }) => (
              <Mask.Phone
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...field}
                id="phoneNumber"
                placeholder="(00) 99999-9999"
                value={values.phoneNumber || ''}
                onAccept={(value) => setFieldValue('phoneNumber', value)}
              />
            )}
          </Form.ValidationField>
          {touched?.phoneNumber && errors?.phoneNumber ? (
            <Form.Hint className="text-error">
              {String(errors.phoneNumber)}
            </Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-6">
        <Form.Group>
          <Form.Label htmlFor="birthdayDate">
            Data de nascimento
          </Form.Label>
          <Form.ValidationField name="birthdayDate">
            {({ field }) => (
              <Form.DatePickerField
                name="birthdayDate"
                dateFormat="dd/MM/yyyy"
                className="form-input"
                id="birthdayDate"
                placeholderText="Aniversário do parceiro/prefeitura"
                selected={field.value ? new Date(field.value) : null}
              />
            )}
          </Form.ValidationField>
          {touched?.birthdayDate && errors?.birthdayDate ? (
            <Form.Hint className="text-error">
              {String(errors.birthdayDate)}
            </Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
    </>
  )
}

FormFields.propTypes = {
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default FormFields
